import {
	Button,
	em,
	Flex,
	Group,
	Radio,
	Select,
	Stack,
	Textarea,
	TextInput,
	Title,
} from '@mantine/core'
import { useMediaQuery } from '@mantine/hooks'
import React, { useState } from 'react'

interface AddressForm {
	fullName: string
	phoneNumber: string
	region: string
	city: string
	zone: string
	address: string
	landmark?: string
	addressType: 'home' | 'office'
}

const AddNewAddress: React.FC = () => {
	const isMobile = useMediaQuery(`(max-width: ${em(768)})`)
	const [form, setForm] = useState<AddressForm>({
		fullName: '',
		phoneNumber: '',
		region: '',
		city: '',
		zone: '',
		address: '',
		landmark: '',
		addressType: 'home',
	})

	const handleChange = (field: keyof AddressForm, value: string) => {
		setForm((prev) => ({
			...prev,
			[field]: value,
		}))
	}

	const handleSubmit = () => {
		console.log('Address Submitted:', form)
		// Add API call or validation here
	}

	return (
		<Stack gap='lg' w={isMobile ? '100%' : '80%'} my={30} mx='auto'>
			<Title order={3}>Add New Address</Title>

			<Flex gap={20}>
				<TextInput
					label='Full Name'
					w={isMobile ? '100%' : '50%'}
					placeholder='John Doe'
					value={form.fullName}
					onChange={(e) => handleChange('fullName', e.currentTarget.value)}
					radius={'md'}
					required
				/>
				<TextInput
					label='Phone Number'
					placeholder='+1234567890'
					w={isMobile ? '100%' : '50%'}
					value={form.phoneNumber}
					radius={'md'}
					onChange={(e) => handleChange('phoneNumber', e.currentTarget.value)}
					required
				/>
			</Flex>
			<Flex gap={20}>
				<Select
					label='Region'
					w={isMobile ? '100%' : '50%'}
					placeholder='Select region'
					data={['Region A', 'Region B', 'Region C']}
					radius={'md'}
					value={form.region}
					onChange={(value) => handleChange('region', value || '')}
					required
				/>

				<Select
					label='City'
					w={isMobile ? '100%' : '50%'}
					placeholder='Select city'
					data={['City X', 'City Y', 'City Z']}
					value={form.city}
					radius={'md'}
					onChange={(value) => handleChange('city', value || '')}
					required
				/>
			</Flex>
			<Flex gap={20}>
				<Select
					label='Zone'
					w={isMobile ? '100%' : '50%'}
					placeholder='Select zone'
					data={['Zone 1', 'Zone 2', 'Zone 3']}
					value={form.zone}
					radius={'md'}
					onChange={(value) => handleChange('zone', value || '')}
					required
				/>

				<Textarea
					label='Address'
					w={isMobile ? '100%' : '50%'}
					placeholder='Full address'
					value={form.address}
					radius={'md'}
					onChange={(e) => handleChange('address', e.currentTarget.value)}
					required
				/>
			</Flex>

			<Flex gap={20}>
				<Textarea
					label='Landmark (Optional)'
					placeholder='Near the mall, etc.'
					w={isMobile ? '100%' : '50%'}
					radius={'md'}
					value={form.landmark}
					onChange={(e) => handleChange('landmark', e.currentTarget.value)}
				/>

				<Radio.Group
					label='Address Type'
					w={isMobile ? '100%' : '50%'}
					value={form.addressType}
					onChange={(value) =>
						handleChange('addressType', value as 'home' | 'office')
					}
				>
					<Group mt='xs'>
						<Radio value='home' label='Home' />
						<Radio value='office' label='Office' />
					</Group>
				</Radio.Group>
			</Flex>

			<Button onClick={handleSubmit} fullWidth size='lg' radius={'lg'}>
				Save Address
			</Button>
		</Stack>
	)
}

export default AddNewAddress
